<template>
    <el-select v-model="val" :placeholder="$strings('word/page_size')" @change="onChange" @clear="onChange"
               :class="hclass" size="small">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
    </el-select>
</template>

<script>
export default {
    name: "filter-size",
    props: ['hclass', 'value'],
    data() {
        return {
            val: '',
            options: [
                {label: 8, value: 8},
                {label: 15, value: 15},
                {label: 20, value: 20}
            ],
        }
    },
    methods: {
        onChange() {
            this.$emit('input', this.val);
        }
    }
}
</script>

<style scoped>

</style>